'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.ProductService = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _utils = require('../core/utils');

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ENABLE_MRMS = true;

// Service to get product information - for editing in Omistajaliittymä and for
// display in reservations (K&K)

var ProductService = exports.ProductService = function () {
    function ProductService(winresCloudService, userService, $q) {
        _classCallCheck(this, ProductService);

        this.$q = $q;
        this.winresCloudService = winresCloudService;
        this.userService = userService;
        this.cachedOwnerProductList = null;
        this.cachedOwnerProductListOwnerNumber = null;
        this.cachedOwnerProductListRoleID = null;
    }

    // Omistajaliittymä


    _createClass(ProductService, [{
        key: 'getOwnerProductListCached',
        value: function getOwnerProductListCached(ownerNumber, roleID) {
            if (this.cachedOwnerProductListOwnerNumber === ownerNumber && this.cachedOwnerProductListRoleID === roleID) {
                return this.$q.when(this.cachedOwnerProductList);
            } else {
                return this.getOwnerProductList(ownerNumber, roleID);
            }
        }

        // Omistajaliittymä

    }, {
        key: 'getOwnerProductList',
        value: function getOwnerProductList(ownerNumber, roleID, language) {
            var t = this;
            return this.winresCloudService.makeAuthenticatedRequest('GetOwnerProductList', { "OwnerNumber": ownerNumber,
                "Language": language }).then(function (list) {
                t.cachedOwnerProductList = list;
                t.cachedOwnerProductListOwnerNumber = ownerNumber;
                t.cachedOwnerProductListRoleID = roleID;
                return list;
            });
        }

        // Omistajaliittymä

    }, {
        key: 'getProductPricePeriodList',
        value: function getProductPricePeriodList(product, language) {
            return this.winresCloudService.makeAuthenticatedRequest('GetWinresProductPricePeriodList', {
                "DestCode": product.DestinationCode,
                "ProdCode": product.ProductCode,
                "Language": language
            });
        }

        // Omistajaliittymä

    }, {
        key: 'getProductPricePeriod',
        value: function getProductPricePeriod(product, pricePeriod, language) {
            return this.winresCloudService.makeAuthenticatedRequest('GetWinresProductPriceRow', {
                "DestCode": product.DestinationCode,
                "ProdCode": product.ProductCode,
                "DatePeriod": pricePeriod,
                "Language": language
            });
        }

        // Omistajaliittymä

    }, {
        key: 'saveProduct',
        value: function saveProduct(product, language) {
            console.log('=================saveProduct==================');
            console.log(product);
            console.log('=================saveProduct==================');
            return this.winresCloudService.makeAuthenticatedRequest('StoreWinresProduct', {
                "DestinationInfo": product,
                "Lg": language
            });
        }

        // Kapasiteettikalenteri nopeammin ilman omistajatietoja

    }, {
        key: 'getCapacityCalendar',
        value: function getCapacityCalendar(destCode, prodCode, isPackage) {
            return this.winresCloudService.makeAuthenticatedRequest('GetCapacityCalendar', {
                DestCode: destCode,
                ProdCode: prodCode,
                IsPackage: !!isPackage
            });
        }

        // Omistajaliittymä / kapasiteetin haku

    }, {
        key: 'getProductCapacities',
        value: function getProductCapacities(productListItem, ignoreClosingDate) {
            return this.winresCloudService.makeAuthenticatedRequest('GetWinresProductCapacityList', {
                "DestCode": productListItem.DestinationCode,
                "ProdCode": productListItem.ProductCode,
                "BeginDate": null,
                "IgnoreClosingDate": ignoreClosingDate
            });
        }

        // Omistajaliittymä

    }, {
        key: 'saveProductCapacities',
        value: function saveProductCapacities(destCode, prodCode, beginDate, endDate, kapsi, sulkuaika, language) {
            return this.winresCloudService.makeAuthenticatedRequest('StoreWinresProductCapacities', {
                "DestinationCode": destCode,
                "ProductCode": prodCode,
                "BeginDate": beginDate,
                "EndDate": endDate,
                "Capacity": kapsi,
                "ClosingLimit": sulkuaika
            });
        }

        // Omistajaliittymä / 2016-03-31 StoreWinresProductPrices(WinresPrice PriceRow, Authenticate Auth)

    }, {
        key: 'saveProductPricePeriod',
        value: function saveProductPricePeriod(pricePeriod, language) {
            return this.winresCloudService.makeAuthenticatedRequest('StoreWinresProductPrices', {
                "PriceRow": Object.assign({}, pricePeriod, {
                    Prices: _.map(pricePeriod.Prices, function (p) {
                        return Object.assign({}, p, {
                            // Do not send net prices. They will be calculated
                            // in the backend from the gross prices.
                            // The opposite, sending net prices and having gross
                            // prices calculated, is not currently supported.
                            NetPrice: null
                        });
                    })
                })
            }, true);
        }

        // Omistajaliittymä

    }, {
        key: 'getWinresTypeList',
        value: function getWinresTypeList(language) {
            return this.winresCloudService.makeAuthenticatedRequest('GetWinresCommonTypesList', {
                "Lg": language
            });
        }

        // Used in K&K 2.0
        // Type in ('accommodation', 'cabin', 'room', 'common')
        // ReservationMode "Conference" or "PackageTour", affects pricing.
        // searchCriteria is:
        // {
        //  DestinationCode: 'ASD123',
        //  ProductCode: 'AH4',
        //  StartDate: '2017-01-02',
        //  EndDate: '2017-01-03',
        //  PriceGroup: 'N0' (defaults to NR)
        // }

    }, {
        key: 'getReservableProducts',
        value: function getReservableProducts(searchCriteria, language) {
            var cacheKey = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;

            // Make sure the Flags parameter isn't null so we can add to it
            Object.assign(searchCriteria, {
                Flags: searchCriteria.Flags || []
            });

            searchCriteria.Flags.push('CheckSinglePassengerPrice');

            if (ENABLE_MRMS) {
                searchCriteria.Flags.push('IncludeMRMS');
            }

            return this.winresCloudService.makeAuthenticatedRequest('GetReservableProducts', {
                SearchCriteria: searchCriteria,
                Language: language
            }, undefined, undefined, cacheKey);
        }

        // Get first reservable product in destination.

    }, {
        key: 'getReservableProduct',
        value: function getReservableProduct(destCode, prodCode, language, minCapacity) {
            var _this = this;

            // Used indentify cached request.
            var cacheKey = destCode + '-' + prodCode;

            return this.$q(function (resolve) {
                _this.getReservableProducts({ DestinationCode: destCode,
                    ProductCode: prodCode,
                    MinCapacity: minCapacity
                }, language, cacheKey).then(function (products) {
                    // Get first product in destination.
                    resolve(products[0]);
                });
            });
        }
    }, {
        key: 'getBusRoutesByDestinationCode',
        value: function getBusRoutesByDestinationCode(destinationCode) {
            return this.winresCloudService.makeAuthenticatedRequest('GetBusRoutes', {
                DestinationCode: destinationCode
            });
        }

        // As getReservableProducts, but only returns a single product or the reason
        // why that product is not available.
        // Calling this with parameters that result in more than one product is an
        // error. You probably want to set ProductCode.

    }, {
        key: 'getReservableProductOrReasonWhyNotReservable',
        value: function getReservableProductOrReasonWhyNotReservable(searchCriteria, language) {
            // Make sure the Flags parameter isn't null so we can add to it
            Object.assign(searchCriteria, {
                Flags: searchCriteria.Flags || []
            });

            searchCriteria.Flags.push('CheckSinglePassengerPrice');

            if (ENABLE_MRMS) {
                searchCriteria.Flags.push('IncludeMRMS');
            }

            // Dummy
            // if (searchCriteria.DiscountCode) {
            //     return this.getReservableProductOrReasonWhyNotReservableWithDiscountCode(searchCriteria, language);
            // }

            return this.winresCloudService.makeAuthenticatedRequest('GetReservableProductOrReasonWhyNotReservable', {
                SearchCriteria: searchCriteria,
                Language: language
            });
        }

        //  DestinationCode: 'ASD123',
        //  ProductCode: 'AH4',
        //  StartDate: '2017-01-02',
        //  EndDate: '2017-01-03',
        //  PriceGroup: 'N0' (defaults to NR)
        // }

    }, {
        key: 'getReservablePrices',
        value: function getReservablePrices(searchCriteria, language) {
            console.log('===========getReservablePrices==============');
            console.log(searchCriteria);
            console.log('===========getReservablePrices==============');
            return this.winresCloudService.makeAuthenticatedRequest('GetReservablePrices', {
                SearchCriteria: searchCriteria,
                Language: language
            });
        }
    }, {
        key: 'searchReservableItems',
        value: function searchReservableItems() {
            return this.winresCloudService.makeAuthenticatedRequest('SearchReservableItems', {
                SearchCriteria: searchCriteria,
                Language: language
            });
        }
        // Used in extra service component (at least K&K 2.0)
        // Returns { '0': [ ... ], '1': [ ... ] }, key is the group index in linking.
        // Non-linked products go to group 0.

    }, {
        key: 'getReservableProductsGrouped',
        value: function getReservableProductsGrouped(searchCriteria, language) {
            return this.getReservableProducts(searchCriteria, language).then(function (products) {
                return _.groupBy(products, function (p) {
                    return p.LinkingInfo ? p.LinkingInfo.GroupID : 0;
                });
            });
        }

        // Used in K&K 2.0 accommodation component
        // Returns [ { Producer: { ... }, Products: [ { ... } ... ] ]

    }, {
        key: 'getReservableProductsGroupedByProducer',
        value: function getReservableProductsGroupedByProducer(searchCriteria, language) {
            return this.getReservableProducts(searchCriteria, language).then(function (products) {
                var grouped = _.groupBy(products, function (product) {
                    return product.Producer ? product.Producer.Number : 0;
                });
                var producers = _.uniq(_.map(products, function (r) {
                    return r.Producer ? r.Producer.Number : 0;
                }));

                return _.map(producers, function (producerNumber) {
                    return {
                        Products: grouped[producerNumber],
                        Producer: grouped[producerNumber][0].Producer
                    };
                });
            });
        }
    }, {
        key: 'getAccommodationPackage',
        value: function getAccommodationPackage(destCode, startDate, endDate, language) {
            return this.winresCloudService.makeAuthenticatedRequest('GetWinresAccommodationPackage', {
                DestinationCode: destCode,
                StartDate: startDate,
                EndDate: endDate,
                Language: language
            });
        }
    }, {
        key: 'getCriteriaDefs',
        value: function getCriteriaDefs(flags) {
            return this.winresCloudService.makeAuthenticatedRequest('GetCriteriaDefs', {
                "DisplayFlags": flags
            }).then(function (results) {
                return _.mapValues(results, function (cri) {
                    return _.omit(cri, '__type');
                });
            });
            // Remove unneeded __type field from criteria objects
        }

        // Joiku

    }, {
        key: 'getProductDistances',
        value: function getProductDistances(destinationCode, productCode, flags, language) {
            return this.winresCloudService.makeAuthenticatedRequest('GetProductDistances', {
                "DestinationCode": destinationCode,
                "ProductCode": productCode,
                "DisplayFlags": flags,
                "Language": language
            });
        }

        // Joiku

    }, {
        key: 'getProductFeatures',
        value: function getProductFeatures(destinationCode, productCode, flags, language) {
            return this.winresCloudService.makeAuthenticatedRequest('GetProductFeatures', {
                "DestinationCode": destinationCode,
                "ProductCode": productCode,
                "DisplayFlags": flags,
                "Language": language
            });
        }
    }, {
        key: 'getProductReview',
        value: function getProductReview(destinationCode, productCode) {
            return this.winresCloudService.makeAuthenticatedRequest('GetProductReview', {
                "DestinationCode": destinationCode,
                "ProductCode": productCode
            });
        }
    }, {
        key: 'getForbiddenDays',
        value: function getForbiddenDays(startDate, endDate) {
            return this.winresCloudService.makeAuthenticatedRequest('GetForbiddenDays', {
                "StartDate": startDate,
                "EndDate": endDate
            });
        }
    }, {
        key: 'getDiscountProducts',
        value: function getDiscountProducts(searchCriteria, results) {
            var _this2 = this;

            var resultsWithDiscountCode = _.filter(results, function (result) {
                return _this2.isValidDiscountCode(result.DestinationInfo.DestinationCode, searchCriteria.DiscountCode, result.BeginDate, result.EndDate);
            });

            _.each(resultsWithDiscountCode, function (result) {
                result.IsDiscount = true;

                // Original price
                result.OriginalPrice = result.ReservablePrices[0].Price;

                // Price after discount
                //result.PriceAfterDiscount = 123;

                result.ReservablePrices[0].Price = 123;

                // Discount product price
                // result.DiscountPrice = -(result.OriginalPrice - result.ReservablePrices[0].Price);
            });
        }

        // Pseudo discount product
        // getDiscountProduct(reducedPrice, beginDate, endDate) {
        //     return {
        //         DestinationInfo: {
        //             DestinationCode: 'XXXX',
        //             ProductCode: 'XX',
        //             ProductName: 'Alennus',
        //         },
        //         BeginDate: beginDate,
        //         EndDate: endDate,

        //         Price: '' + reducedPrice,
        //         ReservablePrices: [
        //             {
        //                 Index: null,
        //                 Label: 'price.labels.accommodation',
        //                 Price: reducedPrice
        //             }
        //         ]
        //     };
        // }

    }, {
        key: 'getReservationFee',
        value: function getReservationFee(contextProducts) {
            var _this3 = this;

            var products = contextProducts;
            var prodListForGetReservFee = _.map(products, function (p) {
                return _this3.productLineForReservationFee(p);
            });

            // Used to identify cached request.
            var cacheKey = _.map(prodListForGetReservFee, function (p) {
                return p.DestinationCode + '|' + p.ProductCode + '|' + p.BeginDate + '|' + p.EndDate + '|' + p.Value + '|' + p.TaxPercentage;
            }).join('-');

            return this.winresCloudService.makeAuthenticatedRequest("GetReservationFee", {
                "FeeCategory": "online",
                "products": prodListForGetReservFee
            }, undefined, undefined, cacheKey);
        }
    }, {
        key: 'getTimeSlots',
        value: function getTimeSlots(destinationCode, productCode, date) {
            var _this4 = this;

            var domain = this.userService.getCurrentUser().getDomain();
            var endpoint = 'Winres/' + domain + '/Destinations/' + destinationCode + '/Products/' + productCode + '/TimeSlots/' + date;

            return this.$q(function (resolve, reject) {
                _this4.winresCloudService.get(endpoint).then(function (result) {
                    return resolve(result.data);
                }, function (error) {
                    return reject(error);
                });
            });
        }
    }, {
        key: 'productLineForReservationFee',
        value: function productLineForReservationFee(line) {
            if (!line.Product.DestinationInfo.DestinationCode) {
                log.error("Tried to prepare productLine for '" + line.Product.DestinationInfo.ProductName + "' getting reservation fee: there is no DestinationCode: ", line.Product.DestinationInfo.DestinationCode);
            }
            if (!line.Product.DestinationInfo.ProductCode) {
                log.error("Tried to prepare productLine for '" + line.Product.DestinationInfo.ProductName + "' getting reservation fee: there is no ProductCode", line.Product.DestinationInfo.ProductCode);
            }
            if (!line.TotalPrice == undefined || line.TotalPrice == NaN) {
                log.error("Tried to prepare productLine for '" + line.Product.DestinationInfo.ProductName + "' getting reservation fee: there is no TotalPrice or it is NaN", line.TotalPrice);
            }
            // New request does not return tax anymore, removing the check, but leaving the rest of tax code, as it can be still used in other things
            // if (!line.Product.TaxPros || line.Product.TaxPros == NaN) {
            //     log.error("Tried to prepare productLine for '" + line.Product.DestinationInfo.ProductName + "' getting reservation fee: there is no TaxPros", line.Product.TaxPros);
            // }
            if (!line.Product.BeginDate) {
                log.error("Tried to prepare productLine for '" + line.Product.DestinationInfo.ProductName + "'  getting reservation fee: there is no ProductCode", line.Product.BeginDate);
            }
            if (!line.Product.EndDate) {
                log.error("Tried to prepare productLine for '" + line.Product.DestinationInfo.ProductName + "'  getting reservation fee: there is no ProductCode", line.Product.EndDate);
            }

            return {
                DestinationCode: line.Product.DestinationInfo.DestinationCode,
                ProductCode: line.Product.DestinationInfo.ProductCode,
                Value: line.TotalPrice,
                TaxPercentage: line.Product.TaxPros,
                BeginDate: line.Product.BeginDate,
                EndDate: line.Product.EndDate
            };
        }
    }, {
        key: 'getDestinationProducts',
        value: function getDestinationProducts(destCode, language) {
            return this.winresCloudService.makeAuthenticatedRequest('GetDestinationProducts', {
                DestCode: destCode,
                Language: language
            });
        }
    }]);

    return ProductService;
}();

ProductService.$inject = ['winresCloudService', 'userService', '$q'];

// Safari object assign fix.
// To fix
// Error in Safari 5.1.7 (7534.57.2):
/*'undefined' is not a function (evaluating 'Object.assign(searchCriteria, {
    Flags: ["CheckSinglePassengerPrice"]
})')*/
if (!Object.assign) {
    Object.defineProperty(Object, 'assign', {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function value(target, firstSource) {
            //'use strict';
            if (target === undefined || target === null) {
                throw new TypeError('Cannot convert first argument to object');
            }

            var to = Object(target);
            for (var i = 1; i < arguments.length; i++) {
                var nextSource = arguments[i];
                if (nextSource === undefined || nextSource === null) {
                    continue;
                }

                var keysArray = Object.keys(Object(nextSource));
                for (var nextIndex = 0, len = keysArray.length; nextIndex < len; nextIndex++) {
                    var nextKey = keysArray[nextIndex];
                    var desc = Object.getOwnPropertyDescriptor(nextSource, nextKey);
                    if (desc !== undefined && desc.enumerable) {
                        to[nextKey] = nextSource[nextKey];
                    }
                }
            }
            return to;
        }
    });
}


//////////////////
// WEBPACK FOOTER
// ./src/winresCloud/productService.js
// module id = 558
// module chunks = 2